/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Account_N_Technical__Answer_1Inputs */

const en_help_center__account_n_technical__answer_1 = /** @type {(inputs: Help_Center__Account_N_Technical__Answer_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes! Log in to your account and go to "Settings" > "Profile." You can update your shipping address, phone number, and notification preferences.`)
};

/**
* | output |
* | --- |
* | "Yes! Log in to your account and go to \"Settings\" > \"Profile.\" You can update your shipping address, phone number, and notification preferences." |
*
* @param {Help_Center__Account_N_Technical__Answer_1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__account_n_technical__answer_1 = /** @type {((inputs?: Help_Center__Account_N_Technical__Answer_1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Account_N_Technical__Answer_1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__account_n_technical__answer_1(inputs)
});